import { httpClient } from '@/Common/api/http_client';

/**
 *
 * @returns {*}
 */
export function fetchAllAvailable() {
  return httpClient.get('/merchant/available-day');
}

/**
 *
 * @returns {*}
 */
export function fetchMerchantProfile() {
  return httpClient.get('/merchant');
}

/**
 *
 * @param merchantId
 * @param data
 * @returns {*}
 */
export function saveMerchantProfile(merchantId, data) {
  return httpClient.post(`/merchant/merchant-profile/${merchantId}`, data);
}

/**
 *
 * @returns {*}
 */
export function fetchDeliveryMethod() {
  return httpClient.get('/merchant/delivery-methods');
}

/**
 *
 * @returns {*}
 */
export function fetchPaymentMethod() {
  return httpClient.get('/merchant/payment-methods');
}

/**
 *
 * @returns {*}
 */
export function fetchDeliveryOption() {
  return httpClient.get('/merchant/delivery-options');
}

/**
 *
 * @returns {*}
 */
export function fetchMerchantConfig() {
  return httpClient.get('/merchant/merchant-config');
}

/**
 *
 * @returns {*}
 */
export function fetchMerchantDeliveryOptions(merchantId) {
  return httpClient.get(`/merchant/delivery_options/${merchantId}`);
}

/**
 *
 * @returns {*}
 */
export function fetchSocialAuth() {
  return httpClient.get('/social_auth');
}

/**
 *
 * @param configId
 * @param data
 * @returns {*}
 */
export function saveMerchantConfig(configId, data) {
  return httpClient.put(`/merchant/merchant-config/${configId}`, data);
}

/**
 *
 * @param type
 * @param data
 * @param merchantId
 * @returns {*}
 */
export function uploadMerchantImages(type, data, merchantId) {
  return httpClient.post(`/merchant/image-upload?type=${type}&merchant_id=${merchantId}`, data);
}

/**
 *
 * @param id
 * @returns {*}
 */
export function deleteMerchantImages(id) {
  return httpClient.delete(`/merchant/image-upload/${id}`);
}

/**
 *
 * @param ids
 * @param merchantId
 * @returns {*}
 */
export function attachDeliveryOptions(merchantId, ids) {
  return httpClient.post(`/merchant/attach_delivery_options/${merchantId}`, { ids });
}

/**
 *
 * @returns {*}
 */
export function getHomeDeliveryOptions() {
  return httpClient.get('/merchant/home_delivery_options');
}
